import styled from 'styled-components';
import { TableBase } from 'features/shared/ui/Table';

export const ScrollWrapper = styled.div`
  height: 510px;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const Table = styled(TableBase)`
  th {
    height: 60px;
  }
`;
